import { useQuery } from '@tanstack/react-query';
import {
  gqlClient,
  graphql,
  type Notes_NotesFilter,
  Notes_TagCategory,
  queryClient,
  type UseQueryReturnType,
} from '@tyro/api';
import { peopleKeys } from '../keys';

export type ReturnTypeFromUseNotes = UseQueryReturnType<
  typeof useNotes
>[number];

const notes = graphql(/* GraphQL */ `
  query notes_notes($filter: Notes_NotesFilter!) {
    notes_notes(filter: $filter) {
      id
      note
      createdOn
      createdBy
      createdByPerson {
        partyId
        title {
          id
          name
          nameTextId
        }
        firstName
        lastName
        avatarUrl
        type
      }
      tags {
        id
        name
        category
        descriptionTextId
        nameTextId
        colour
      }
      priorityNote
      priorityStartDate
      priorityEndDate
      pbac {
        isSecured
      }
    }
  }
`);

const notesQuery = (filter: Notes_NotesFilter) => {
  const updatedFilter = { ...filter, noteType: Notes_TagCategory.Note };

  return {
    queryKey: peopleKeys.students.notes(updatedFilter),
    queryFn: async () =>
      gqlClient.request(notes, {
        filter: updatedFilter,
      }),
  };
};

export function getNotes(filter: Notes_NotesFilter) {
  return queryClient.fetchQuery(notesQuery(filter));
}

export function useNotes(filter: Notes_NotesFilter, enabled = true) {
  return useQuery({
    ...notesQuery(filter),
    select: ({ notes_notes }) => notes_notes,
    enabled,
  });
}
